<template>
    <Claim :ServiceID="AppServiceID"></Claim>
</template>
<script>
import Claim from '@/components/Dental/Claim.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default { 
data: function () {
    return { 
         AppServiceID:''
        }
    },
 components: {
    Claim  : Claim 
        },
   created: function() {
       this.$emit('update:layout', LayoutDefault);
        this.AppServiceID = this.$store.getters.GetDentalID;
    },
    beforeCreate: function() {
       this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
       this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
    },
}
</script>
